import { Box, Typography } from "@mui/material";
import Table, { ColumnType } from "components/Table";
import sortHandler from "components/Table/SortHandler";
import { SortDirection } from "data/constants";
import useTitle from "hooks/useTitle";
import _ from "lodash";
import { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResType } from "types";
import { Permissions } from "data/permissons";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import { getComplianceNewUpdates } from "api/services/automation/compliance";
import SearchContainer from "components/SearchContainer";

const ComplianceNewUpdates = () => {
    useTitle('ATOM Pro | Updates')
    const navigate = useNavigate()
    const { permissions } = usePermissions();
    const [sort, setSort] = useState<any>({});
    const [search, setSearch] = useState("");
    const { data, isLoading }: ResType = useQuery(
        ["compliance-new-updates", {
            sort,
            search,
        }],

        getComplianceNewUpdates,{
            enabled: permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
        }
    );


    const handleClick = (row) => {
        navigate(`/atom-pro/income-tax/new-updates/${row?.id}`);
    };
    const defaultColumns: Array<ColumnType> = [
        {
            key: "client.displayName",
            title: "Client (PAN)",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
              render: (row) => <Typography>
                {row?.client?.displayName} (<span>{row?.client?.autClientCredentials[0]?.panNumber}</span>)
            </Typography>
        },
        {
            key: "id",
            title: "e-Campaign",
            render: (row) => <Typography>{row?.eCampaign?.newItem?.length}</Typography>
        },
       
    ]

    const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
    const handleSort = (v: any) => {
        sortHandler({
            key: v.key,
            columns,
            sortState: sort,
            setSortState: setSort,
            setColumns: setColumns,
        });
    };

      const handleSearch = (e: any) => {
        setSearch(e);
    };

    if (!(permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS))) {
        return <AccessDenied />
    }

    return (

        <Box sx={{ padding: 1 }} overflow="auto">
            <Box mb={1}>
                <SearchContainer
                    minWidth="330px"
                    value={search}
                    debounced
                    placeHolder="Search by Client Name | PAN"
                    onChange={handleSearch}
                />
            </Box>
            <Table
                sx={{ pb: 0, mb: 0, height: '575px' }}
                data={data?.data || []}
                columns={columns}
                sortHandler={handleSort}
                loading={isLoading}
                onRowClick={handleClick}
            />
            {/* <Typography variant="h6" gutterBottom>Returns Changes</Typography>
            {data?.data?.map((update: any, index: any) => (
                <Box key={index} sx={{ marginBottom: 2, borderBottom: '1px solid #ccc', paddingBottom: 2 }} >
                    <Typography variant="subtitle1" color="#0066cc">Client Name : {update?.client?.displayName}</Typography>
                    {
                        update?.returns?.updateItem && update?.returns?.updateItem?.length > 0 && (
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="h6" color={"primary"}>Updated Returns : {update?.returns?.updateItem?.length}</Typography>
                                </Grid>
                                {update?.returns?.updateItem?.map(item => (
                                    <Grid item xs={4} >
                                        <Card key={item.id} sx={{ padding: 1 }} onClick={() => handleBoxClick(item.id)} >

                                            <Typography variant="body2"><span style={{ fontWeight: "600", color: "#004d99" }}>Acknowledgment Number : </span>{item?.ackNum}</Typography>
                                            {item.changes && (
                                                <Box sx={{ marginTop: 1 }}>
                                                    {item?.changes?.newList?.length > 0 && (
                                                        <Box>
                                                            <Typography variant="body2"><span style={{ fontWeight: "600", color: "#004d99" }}>New Status : </span> {item?.changes?.newList?.[0]?.statusDesc}</Typography>
                                                        </Box>
                                                    )}
                                                    {item?.changes?.oldList?.length > 0 && (
                                                        <Box>
                                                            <Typography variant="body2"> <span style={{ fontWeight: "600", color: "#004d99" }}>Old Status : </span> {item?.changes?.oldList[0]?.statusDesc}</Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            )}
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )
                    }

                    {
                        update?.returns?.newItem && update?.returns?.newItem?.length > 0 && (
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="h6" color={"primary"}>New Returns : {update?.returns?.newItem?.length}</Typography>
                                </Grid>

                                {update?.returns?.newItem?.map(item => (
                                    <Grid item xs={4} key={item.id}>
                                        <Card >
                                            <Grid item sx={{ marginBottom: 1 }} onClick={() => handleBoxClick(item.id)} bgcolor={"#ffffff"} m={0.5} padding={0.5}>
                                                <Typography variant="body2"> <span style={{ fontWeight: "600", color: "#00264d" }}>Acknowledgment Number : </span> {item?.ackNum}</Typography>
                                                <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>assmentYear : </span> {item?.assmentYear}</Typography>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )
                    }

                    <UpdatesForms forms={update?.forms} />
                    <UpdatesOutstandingDemand demands={update?.outstandingDemand} />
                    <UpdatesEproceedingFya eProceedingFya={update?.eProceedingFya} />
                    <UpdatesEproceedingFyi eProceedingFyi={update?.eProceedingFyi} />
                </Box>
            ))} */}
        </Box>
    );
};

export default ComplianceNewUpdates;
